var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7153 23.1435C22.9575 23.1435 22.2307 22.8425 21.6948 22.3067C21.159 21.7708 20.858 21.044 20.858 20.2862C20.858 19.5284 21.159 18.8017 21.6948 18.2658C22.2307 17.73 22.9575 17.429 23.7153 17.429C24.4731 17.429 25.1998 17.73 25.7357 18.2658C26.2715 18.8017 26.5726 19.5284 26.5726 20.2862C26.5726 20.6615 26.4986 21.033 26.3551 21.3797C26.2115 21.7263 26.001 22.0413 25.7357 22.3067C25.4703 22.572 25.1554 22.7824 24.8087 22.926C24.462 23.0696 24.0905 23.1435 23.7153 23.1435ZM23.7153 12.2858C21.5934 12.2858 19.5585 13.1287 18.0581 14.6291C16.5577 16.1295 15.7148 18.1644 15.7148 20.2862C15.7148 26.2866 23.7153 35.1442 23.7153 35.1442C23.7153 35.1442 31.7157 26.2866 31.7157 20.2862C31.7157 18.1644 30.8728 16.1295 29.3724 14.6291C27.872 13.1287 25.8371 12.2858 23.7153 12.2858Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.7d0f3aa3e26d4bd80955ce22b5d179e8.svg";
export { ForwardRef as ReactComponent };